export const RUSH_OPTIONS = [
    { id: 0, label: 'No Rush', feePercentage: 0, daysToSubtract: 0 },
    { id: 1, label: '9 Day Rush', feePercentage: 5, daysToSubtract: 1 },
    { id: 2, label: '8 Day Rush', feePercentage: 6, daysToSubtract: 2 },
    { id: 3, label: '7 Day Rush', feePercentage: 8, daysToSubtract: 3 },
    { id: 4, label: '6 Day Rush', feePercentage: 10, daysToSubtract: 4 },
    { id: 5, label: '5 Day Rush', feePercentage: 12, daysToSubtract: 5 },
    { id: 6, label: '4 Day Rush', feePercentage: 25, daysToSubtract: 6 },
    { id: 7, label: '3 Day Rush', feePercentage: 50, daysToSubtract: 7 },
    { id: 8, label: '2 Day Rush', feePercentage: 60, daysToSubtract: 8 },
    { id: 9, label: '1 Day Rush', feePercentage: 100, daysToSubtract: 9 }
];
